<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-07-02 11:24:30
 * @LastEditors: voanit
 * @LastEditTime: 2021-07-30 10:03:35
-->
<template>
  <div class="email-detail-wrapper">
    <el-card>
      <el-tabs v-model="params.activeTab" @tab-click="handleTab">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tabs" :key="index"></el-tab-pane>
        <component :is="params.activeTab" :params="params" style="margin-top: 10px;" />
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import inOutMail from './in-out-mail'
import orderInfo from './order'
import detailInfo from './detail'

export default {
  name: 'email-detail',
  components: {
    detailInfo: detailInfo,
    orderInfo,
    inOutMail
  },
  data() {
    return {
      tabs: [
        { label: this.$t('after-sales::in-box::email_detail'), name: 'detailInfo' },
        { label: this.$t('after-sales::in-box::history_order'), name: 'orderInfo' },
        { label: this.$t('after-sales::in-box::in_out_mail'), name: 'inOutMail' }
      ],
      params: {
        activeTab: 'detailInfo'
      }
    }
  },
  watch: {
    $route: {
      handler: function(to, from) {
        console.log(to, from)
        if (to.name === 'email-detail') {
          if (to.query && to.query.name) {
            this.params.activeTab = to.query.name
          }
          if (to.query && to.query.emailId) {
            this.params = {
              ...this.params,
              changeEmailId: to.query.changeEmailId,
              changeShopId: to.query.changeShopId,
              changeType: to.query.changeType,
              emailId: to.query.emailId,
              type: to.query.type,
              shopId: to.query.shopId
            }
          }
        }
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    handleTab(tab) {
      this.params.activeTab = tab.name
      this.$router.replace({
        path: '/email-detail',
        query: {
          emailId: this.params.emailId,
          name: this.params.activeTab,
          type: this.params.type,
          shopId: this.params.shopId
        }
      })
    },
    init(params) {}
  }
}
</script>
<style lang="scss" scoped></style>
